{
  "nav": {
    "pricing": "Tarieven",
    "contact": "Contact",
    "menu": "Menu",
    "login": "Inloggen",
    "features": "Functies",
    "brandHomeAria": "Done-it — home",
    "market": {
      "belgium": "België",
      "international": "Wereldwijd"
    }
  },
  "footer": {
    "tagline": "Done-it — Eenvoudige tijdsregistratie.",
    "terms": "Voorwaarden",
    "privacy": "Privacy",
    "contact": "Contact"
  },
  "help": "Hulp nodig?",
  "continue": "Doorgaan",
  "back": "Terug",
  "change": "Wijzigen",
  "retry": "Opnieuw proberen",
  "errors": {
    "unexpected": "Onverwachte fout"
  },
  "step": {
    "of": "Stap {{n}} van {{total}}"
  },
  "funnel": {
    "title": "Abonnement · Done-it"
  }
}
